export default function TrustSafety() {
  const cards = [
    {
      icon: 'ri-shield-check-line',
      title: 'Safety Disclaimer',
      description: 'This website provides educational information about Litbuy Spreadsheet. We do not store user data, and we are not officially affiliated with Litbuy. Users should always verify information before making business decisions.',
    },
    {
      icon: 'ri-lock-line',
      title: 'Privacy Notice',
      description: 'Your privacy matters. We do not collect personal information, track browsing behavior, or use cookies for advertising purposes. External links may lead to third-party websites with their own privacy policies.',
    },
    {
      icon: 'ri-file-text-line',
      title: 'Data Security',
      description: 'Use spreadsheet tools responsibly and maintain your own data backups. We recommend reviewing security settings and keeping software updated to protect your important business data at all times.',
    },
  ];

  return (
    <section className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="flex flex-col items-start mb-12">
          <div className="flex items-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-accent-600 tracking-wider uppercase">
              Trust &amp; Safety
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-1">
            Safe &amp; Transparent
          </h2>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight mb-3">
            Spreadsheet Guides
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg">
            We are committed to providing honest, transparent, and reliable information about Litbuy Spreadsheet.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {cards.map((card, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-2xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
                <i className={`${card.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {card.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4">
                {card.description}
              </p>

              {/* Source info */}
              <div className="flex items-center gap-2 pt-3 border-t border-background-200/60">
                <div className="w-6 h-6 rounded-full bg-secondary-200 flex items-center justify-center text-secondary-600 text-xs font-bold">
                  L
                </div>
                <div className="flex flex-col">
                  <span className="text-xs font-medium text-foreground-700">Litbuy Team</span>
                  <span className="text-[10px] text-foreground-400">Verified Source</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}